module.exports = __webpack_public_path__ + "img/fpb.ee88e8de.svg";